module.exports = __webpack_public_path__ + "assets/logo-white.5a0c6665.svg";